module.exports = __webpack_public_path__ + "static/media/EM-icons-3@3x.962f8bcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/EM-icons-3@3x.png
// module id = 1696
// module chunks = 0